const existingTimeInfoRegex = /T\d\d:\d\d:\d\d/

function formatDate(date) {
    return new Date(Date.parse(date)).toLocaleString();
}

function formatDateOnly(date) {
    if (typeof date === "string")
        return new Date(Date.parse(date)).toLocaleDateString({ weekday: "short", year: "numeric", month: "2-digit", day: "numeric" });
    else
        return date.toLocaleDateString({ weekday: "short", year: "numeric", month: "2-digit", day: "numeric" });
}

function formatDateOnlyUtc(date){
    if (typeof date === "string")
        date = new Date(Date.parse(date))

    return new Date(date.toISOString()).toLocaleDateString(undefined, { year: "numeric", month: "2-digit", day: "numeric", timeZone: "UTC" });
}

function convertUTCtoLocalDate(date) {
    date = new Date(Date.parse(date))
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}

function dateStringToDate(date) {
    if (!existingTimeInfoRegex.test(date)){
        date += 'T00:00:00';
    }

    return new Date(date);
}

function convertToMidnight(dateString) {
    const date = new Date(dateString)
    date.setHours(0, 0, 0, 0);
    return date;
}

function getLocalTimezoneName() {
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timezoneName) {
        console.log('Timezone name could not be found');
    }
    return timezoneName
}

function getTimezone() {
    const timezoneName = localStorage.getItem("timezone");
    if (!timezoneName) {
        return '';
    }
    return timezoneName
}

function addTimezoneInformation(date) {

    if (date === undefined)
        return undefined;

    date = new Date(Date.parse(date));

    const offset = -date.getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;

    const timezoneSign = offset >= 0 ? '+' : '-';
    const timezoneString = `${timezoneSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;

    const dateString = date.toISOString().split('Z')[0];

    return `${dateString}${timezoneString}`;
}

function formatPrice(price) {
    price = +price
    return price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

function getDateOnly(date) {
    date = new Date(date);
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`
}

function getTimeOnly(date) {
    date = new Date(date);
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()

    return `${hours}:${minutes}:${seconds}`
}

function getTimeOnly12Hours(date) {
    return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
}

function generateDynamicFields(fields, columnName, hideColumn) {
    return fields?.map(field => {
        if (field.key === columnName) {
            return hideColumn ? { ...field, thClass: 'd-none', tdClass: 'd-none' } : field
        }
        return field
    })
}

function generateFieldsByRole(fields, excludedColumns) {
    return fields?.map(field => {
        if (excludedColumns.includes(field.columnId)) {
            return { ...field, thClass: 'd-none', tdClass: 'd-none' }
        }
        return field
    })
}

function getElapsedReadableTime(ms) {
    var d, h, m, s;
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = Math.trunc(s % 60);
    h = Math.floor(m / 60);
    m = Math.trunc(m % 60);
    d = Math.floor(h / 24);
    h = Math.trunc(h % 24);

    if (d) {
        return d + " days, " + h + " hours, " + m + " minutes, " + s + " seconds ago"
    }
    if (h) {
        return h + " hours, " + m + " minutes, " + s + " seconds ago"
    }
    return m + " minutes, " + s + " seconds ago"
}

function isDateTimeMin(date) {
    if (date === '0001-01-01T00:00:00') {
        return true
    }
    return false
}
function isToday(dateString) {
    const today = new Date()
    const timeZoneInfo = addTimezoneInformation(dateString)
    const targetDate = new Date(timeZoneInfo)
    return targetDate.getFullYear() === today.getFullYear() &&
        targetDate.getMonth() === today.getMonth() &&
        targetDate.getDate() === today.getDate()
}

function isDateAfterToday(date) {
    const today = new Date()
    return date > today
}

function getYesterdaysDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    return yesterday.toISOString();
}

function getDateDifference(startDate, endDate) {
    const msDifference = new Date(endDate) - new Date(startDate);
    const daysDifference = msDifference / (1000 * 60 * 60 * 24);
    return daysDifference;
}

function cleanVmid(vmid) {
    return vmid.replace(/[^0-9]/g, '')
}

function kioskLink(kioskId) {
    var portalId = this.$store.state.auth.portal.id;
    var routeData = this.$router.resolve({
        path: '/kiosk/',
        query: { kiosk_id: kioskId, portal_id: portalId },
    });
    window.open(routeData.href, 'kiosk_' + kioskId);
}

function servantLink(servantId) {
    var routeData = this.$router.resolve({
        path: '/servant/',
        query: { servant_id: servantId },
    });
    window.open(routeData.href, 'servant_' + servantId);
}

function transactionsVmidLink(dateStart, vmid) {
    var routeData = this.$router.resolve({
        path: '/transactions/',
        query: {
            dateStart: dateStart ? addTimezoneInformation(dateStart.slice(0, 10)) : null,
            vmid: vmid
        }
    });
    window.open(routeData.href)
}

function transactionsIdLink(dateStart, transactionId) {
    var routeData = this.$router.resolve({
        path: '/transactions/',
        query: {
            dateStart: addTimezoneInformation(dateStart.toISOString().slice(0, 10)),
            transactionId: transactionId
        }
    });
    window.open(routeData.href)
}

function isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

function openHelpWindow(anchor) {
    let location = '/files/help/Sleegers Kiosk Portal User Guide.html'
    if (anchor !== undefined)
        location += anchor

    window.open(location, "help_guide")
}

function errorToast(error, message) {
    console.log(`${message}: ${error}`);
    this.$root.$refs['toast'].toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
    });
}

function showToast(message, successful) {
    console.log(`${message}`);
    this.$root.$refs['toast'].toast(message, {
        title: successful ? 'Success' : 'Error',
        variant: successful ? 'success' : 'danger',
        solid: true,
    });
}

export {
    formatDate, formatPrice, getDateOnly, getTimeOnly, isToday, isDateAfterToday, getYesterdaysDate, getDateDifference, convertToMidnight, generateDynamicFields, cleanVmid,
    generateFieldsByRole, getElapsedReadableTime, kioskLink, servantLink, transactionsVmidLink, transactionsIdLink, convertUTCtoLocalDate, formatDateOnly,
    getLocalTimezoneName, getTimezone, getTimeOnly12Hours, isDateTimeMin, addTimezoneInformation, isMobile, openHelpWindow, errorToast, showToast, formatDateOnlyUtc, dateStringToDate
}